import { useTranslation } from "react-i18next";
import CarDetailSection from "./CarDetailSection";

function CarChangeLogTab() {
    const { t } = useTranslation("cars");

    return (
        <CarDetailSection
            title={t("carDetail.changeLog")}
            empty
            emptyDescription={t("carDetail.changeLogComingSoon")}
            embedded
            className="!mt-0"
        />
    );
}

export default CarChangeLogTab;
